// Africa'Lingerie — interactions du thème Shopify (panier AJAX, favoris, recherche, quiz, pop-up, Black Friday)
(() => {
  const T = window.THEME || {};
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const prix = c => (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: T.monnaie || 'EUR' });
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const lire = k => { try { return JSON.parse(localStorage.getItem(k)) || []; } catch { return []; } };
  const ecrire = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} };
  const coeur = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10Z"/></svg>';
  const carte = p => `<article class="carte"><a class="carte-image" href="${p.url}">${p.featured_image ? `<img src="${p.featured_image}" alt="${esc(p.title)}" loading="lazy">` : ''}</a>
    <div class="carte-actions"><button class="favori" data-favori="${p.handle}" aria-pressed="false" aria-label="Favori">${coeur}</button></div>
    ${p.available && p.variants.length === 1 ? `<button class="ajout-rapide" data-ajouter="${p.variants[0].id}">Ajouter au panier</button>` : ''}
    <h3><a href="${p.url}">${esc(p.title)}</a></h3><div class="prix">${prix(p.price)}</div></article>`;
  const produitJson = h => fetch(`${T.routes.racine.replace(/\/$/, '')}/products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null);

  /* ---------- Tiroirs et modales ---------- */
  const voile = $('.voile');
  const ouvrir = id => { $('#' + id)?.classList.add('ouvert'); voile?.classList.add('ouvert'); };
  const fermer = () => { $$('.tiroir.ouvert').forEach(t => t.classList.remove('ouvert')); voile?.classList.remove('ouvert'); };
  voile?.addEventListener('click', fermer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { fermer(); $$('.modale').forEach(m => { m.hidden = true; }); } });
  $$('.modale').forEach(m => m.addEventListener('click', e => { if (e.target === m) m.hidden = true; }));

  /* ---------- Panier Shopify ---------- */
  async function majPanier(ouvrirTiroir) {
    const c = await fetch(T.routes.panier + '.js').then(r => r.json());
    $$('[data-compte-panier]').forEach(e => { e.textContent = c.item_count; e.hidden = !c.item_count; });
    $$('[data-total-panier]').forEach(e => { e.textContent = prix(c.total_price); });
    const corps = $('#panier-lignes'), pied = $('#panier-pied');
    if (corps) {
      if (!c.item_count) { corps.innerHTML = `<div class="vide"><p>Votre panier est vide.</p><a class="btn" href="${T.routes.racine}collections/all">Découvrir la boutique</a></div>`; pied.hidden = true; }
      else {
        corps.innerHTML = c.items.map(i => `<div class="ligne-panier"><a href="${i.url}">${i.image ? `<img src="${i.image}" alt="">` : ''}</a>
          <div><h4>${esc(i.product_title)}</h4>${i.variant_title ? `<small>${esc(i.variant_title)}</small>` : ''}<div class="qte"><button data-panier="${i.key}" data-q="${i.quantity - 1}" aria-label="Moins">−</button><span>${i.quantity}</span><button data-panier="${i.key}" data-q="${i.quantity + 1}" aria-label="Plus">+</button></div></div>
          <div style="display:grid;gap:6px;justify-items:end;align-content:start"><span>${prix(i.final_line_price)}</span><button class="retirer" data-panier="${i.key}" data-q="0">Retirer</button></div></div>`).join('');
        pied.hidden = false;
        const wa = $('#panier-whatsapp');
        if (wa) wa.href = `https://wa.me/${T.whatsapp}?text=${encodeURIComponent(`Bonjour Africa'Lingerie, je souhaite commander :\n${c.items.map(i => `• ${i.quantity} × ${i.product_title} (${prix(i.final_line_price)})`).join('\n')}\nTotal : ${prix(c.total_price)}`)}`;
      }
    }
    if (ouvrirTiroir) ouvrir('tiroir-panier');
  }
  async function ajouter(id, quantity) {
    const r = await fetch(T.routes.ajout + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity }] }) });
    if (!r.ok) { const e = await r.json().catch(() => ({})); alert(e.description || 'Produit indisponible'); return; }
    majPanier(true);
  }
  $$('form[data-formulaire-produit]').forEach(f => f.addEventListener('submit', e => { e.preventDefault(); ajouter(f.querySelector('[name=id]').value, +(f.querySelector('[name=quantity]')?.value || 1)); }));

  /* ---------- Favoris ---------- */
  async function majFavoris() {
    const f = lire('al-favoris');
    $$('[data-compte-favoris]').forEach(e => { e.textContent = f.length; e.hidden = !f.length; });
    $$('[data-favori]').forEach(b => b.setAttribute('aria-pressed', f.includes(b.dataset.favori)));
    const g = $('#grille-favoris');
    if (g && !g.dataset.charge) {
      g.dataset.charge = '1';
      const liste = (await Promise.all(f.map(produitJson))).filter(Boolean);
      g.innerHTML = liste.map(carte).join(''); $('#favoris-vide').hidden = liste.length > 0;
      $$('[data-favori]', g).forEach(b => b.setAttribute('aria-pressed', 'true'));
    }
  }

  /* ---------- Clics ---------- */
  document.addEventListener('click', e => {
    const t = e.target.closest('button, a'); if (!t) return;
    const d = t.dataset;
    if (d.ouvrir) { e.preventDefault(); ouvrir(d.ouvrir); if (d.ouvrir === 'tiroir-recherche') $('#champ-recherche')?.focus(); }
    else if ('fermer' in d) fermer();
    else if (d.ajouter) ajouter(d.ajouter, 1);
    else if (d.panier) fetch(T.routes.modif + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: d.panier, quantity: +d.q }) }).then(() => majPanier());
    else if (d.favori) { const f = lire('al-favoris'); ecrire('al-favoris', f.includes(d.favori) ? f.filter(x => x !== d.favori) : [...f, d.favori]); majFavoris(); }
    else if (d.qte) { const i = $('#quantite'); i.value = Math.max(1, +i.value + +d.qte); }
    else if (d.image) { const img = $('#image-principale'); img.src = d.image; img.removeAttribute('srcset'); $$('[data-image]').forEach(b => b.setAttribute('aria-current', b === t)); }
    else if (d.defiler) { const c = t.parentElement.querySelector('.carrousel'); c.scrollBy({ left: (d.defiler === 'suiv' ? 1 : -1) * c.clientWidth * .8 }); }
    else if (d.onglet) { const box = t.closest('[data-onglets]'); $$('[data-onglet]', box).forEach(b => b.setAttribute('aria-selected', b === t)); $$('[data-panneau]', box).forEach(p => { p.hidden = p.dataset.panneau !== d.onglet; }); }
    else if ('fermerModale' in d) $$('.modale').forEach(m => { m.hidden = true; });
    else if (d.agrandir) { const v = $('#visionneuse'); v.querySelector('img').src = d.agrandir; v.hidden = false; }
  });

  /* ---------- Recherche instantanée ---------- */
  const champ = $('#champ-recherche'); let minuterie;
  champ?.addEventListener('input', () => {
    clearTimeout(minuterie);
    minuterie = setTimeout(async () => {
      const q = champ.value.trim(), zone = $('#resultats-recherche');
      if (q.length < 2) { zone.innerHTML = ''; return; }
      const r = await fetch(`${T.routes.recherche}/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10`).then(r => r.json()).catch(() => null);
      const p = r?.resources?.results?.products || [];
      zone.innerHTML = p.length ? p.map(x => `<a class="resultat" href="${x.url}">${x.image ? `<img src="${x.image}" alt="">` : '<span></span>'}<span>${esc(x.title)}<br><b>${x.price} €</b></span></a>`).join('') : '<p>Aucun produit trouvé.</p>';
    }, 250);
  });

  /* ---------- Tri des collections ---------- */
  $$('select[data-tri]').forEach(s => s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u; }));

  /* ---------- Pied de page : menus déroulants fermés sur mobile ---------- */
  if (innerWidth >= 768) $$('.pied-menu').forEach(d => { d.open = true; });

  /* ---------- Compte à rebours Black Friday ---------- */
  $$('[data-compte]').forEach(el => {
    const fin = new Date(el.dataset.compte);
    const maj = () => { const ms = fin - Date.now(); if (isNaN(ms)) return; if (ms <= 0) { el.textContent = el.dataset.termine || ''; return; }
      const j = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60; el.textContent = j ? `Plus que ${j} j ${h} h` : `Plus que ${h} h ${m} min`; };
    maj(); setInterval(maj, 60000);
  });

  /* ---------- Fiche produit : produits récemment consultés ---------- */
  const fiche = $('[data-fiche]');
  if (fiche) {
    const h = fiche.dataset.fiche, vus = [h, ...lire('al-vus').filter(x => x !== h)].slice(0, 9);
    ecrire('al-vus', vus);
    const zone = $('#recents');
    if (zone && vus.length > 1) Promise.all(vus.slice(1).map(produitJson)).then(l => { l = l.filter(Boolean); if (!l.length) return; zone.hidden = false; zone.querySelector('.carrousel').innerHTML = l.map(carte).join(''); majFavoris(); });
  }

  /* ---------- Quiz : besoin puis budget, résultats pré-affichés par Shopify ---------- */
  $$('[data-quiz]').forEach(q => {
    let besoin = null;
    const etape = n => $$('[data-quiz-etape]', q).forEach(e => { e.hidden = e.dataset.quizEtape !== n; });
    q.addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      if (b.dataset.besoin) { besoin = b.dataset.besoin; etape('budget'); }
      else if (b.dataset.budget) {
        const [min, max] = b.dataset.budget.split('-').map(Number), groupe = $(`[data-groupe="${besoin}"]`, q);
        const cartes = $$('.carte', groupe); cartes.forEach(c => { c.hidden = true; });
        let ok = cartes.filter(c => +c.dataset.prix >= min && +c.dataset.prix < max);
        if (ok.length < 3) ok = [...ok, ...cartes.filter(c => !ok.includes(c))];
        ok.slice(0, 3).forEach(c => { c.hidden = false; });
        $$('.quiz-groupe', q).forEach(g => { g.style.display = g === groupe ? 'grid' : 'none'; });
        etape('resultat');
      } else if ('recommencer' in b.dataset) etape('besoin');
    });
  });
  $$('[data-quiz-ouvrir]').forEach(b => b.addEventListener('click', () => { const m = $('#modale-quiz'); if (m) { m.hidden = false; $$('[data-quiz-etape]', m).forEach(e => { e.hidden = e.dataset.quizEtape !== 'besoin'; }); } }));

  /* ---------- Pop-up de bienvenue ---------- */
  const popup = $('#modale-bienvenue');
  if (popup) { let vu = false; try { vu = sessionStorage.getItem('al-bienvenue') === '1'; sessionStorage.setItem('al-bienvenue', '1'); } catch {} if (!vu) setTimeout(() => { popup.hidden = false; }, (+popup.dataset.delai || 1.5) * 1000); }

  /* ---------- Newsletter / contact vers WhatsApp (formulaires marqués) ---------- */
  $$('form[data-whatsapp]').forEach(f => f.addEventListener('submit', e => { e.preventDefault(); window.open(`https://wa.me/${T.whatsapp}?text=${encodeURIComponent(f.dataset.whatsapp + '\n' + [...new FormData(f).entries()].map(([k, v]) => `${k} : ${v}`).join('\n'))}`, '_blank'); }));

  /* ---------- Cœurs qui tombent ---------- */
  if (T.coeurs && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const z = document.createElement('div'); z.className = 'coeurs'; z.setAttribute('aria-hidden', 'true');
    const cols = (T.couleursCoeurs || []).map(c => c.trim()).filter(Boolean), n = innerWidth < 768 ? 7 : 12;
    z.innerHTML = Array.from({ length: n }, (_, k) => `<i style="left:${Math.random() * 100}%;--t:${10 + Math.random() * 12}px;--d:${11 + Math.random() * 10}s;--r:-${Math.random() * 20}s;--rot:${Math.random() > .5 ? '' : '-'}${120 + Math.random() * 200}deg"><svg viewBox="0 0 24 24"><path fill="${cols[k % cols.length] || '#7a1131'}" d="M12 21s-8-5-8-11a4.5 4.5 0 0 1 8-2.8A4.5 4.5 0 0 1 20 10c0 6-8 11-8 11Z"/></svg></i>`).join('');
    document.body.append(z);
  }

  majPanier(); majFavoris();
})();
